import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StartStoreInfoModel } from '../models/stores.model';
import { AppConfig } from 'src/app/app.config';

@Injectable()
export class SecurityService {

    public startStoreInfo: StartStoreInfoModel;
    public currentCountryCode: string;

    constructor(private http: HttpClient) {
        this.currentCountryCode = 'us';
    }

    getStart(): Observable<StartStoreInfoModel> {
        const url = `${AppConfig.apiHost}/api/start`;
        return this.http.get<StartStoreInfoModel>(url);
    }

    accessDashboardNav(): boolean {
        return this.checkSecurity('Dashboard');
    }
    accessCalendarNav(): boolean {
        return this.checkSecurity('Calendar');
    }
    accessBookingsNav(): boolean {
        return this.checkSecurity('Booking');
    }
    accessCrmNav(): boolean {
        return this.checkSecurity('Customer');
    }
    accessReportsNav(): boolean {
        return this.checkSecurity('Report');
    }
    accessStoreNav(): boolean {
        return this.checkSecurity('Store');
    }
    accessGlobalNav(): boolean {
        return this.checkSecurity('Global');
    }
    accessBookingChangeExperience(): boolean {
        return this.checkSecurity('BookingChangeExperience');
    }
    accessBookingChangeAddOns(): boolean {
        return this.checkSecurity('BookingChangeAddOns');
    }
    accessBookingLinkWaivers(): boolean {
        return this.checkSecurity('BookingLinkWaivers');
    }
    accessBookingOpen(): boolean {
        return this.checkSecurity('BookingOpen');
    }
    accessBookingAddCharge(): boolean {
        return this.checkSecurity('BookingAddCharge');
    }
    accessBookingAddDiscount(): boolean {
        return this.checkSecurity('BookingAddDiscount');
    }
    accessBookingAddCoupon(): boolean {
        return this.checkSecurity('BookingAddCoupon');
    }
    accessBookingAddRefundCredit(): boolean {
        return this.checkSecurity('BookingAddRefundCredit');
    }
    accessBookingAddRefundCash(): boolean {
        return this.checkSecurity('BookingAddRefundCash');
    }
    accessBookingAddRefundCheck(): boolean {
        return this.checkSecurity('BookingAddRefundCheck');
    }
    accessBookingAddPaymentCredit(): boolean {
        return this.checkSecurity('BookingAddPaymentCredit');
    }
    accessBookingAddPaymentCash(): boolean {
        return this.checkSecurity('BookingAddPaymentCash');
    }
    accessBookingAddPaymentCheck(): boolean {
        return this.checkSecurity('BookingAddPaymentCheck');
    }


    accessCustomerEdit(): boolean {
        return this.checkSecurity('CustomerEdit');
    }
    accessBookingAdd(): boolean {
        return this.checkSecurity('BookingAdd');
    }
    accessBookingChangeGuestQuantity(): boolean {
        return this.checkSecurity('BookingChangeGuestQuantity');
    }
    accessBookingChangeArrival(): boolean {
        return this.checkSecurity('BookingChangeArrival');
    }
    accessBookingSendInvoice(): boolean {
        return this.checkSecurity('BookingSendInvoice');
    }
    accessBookingAddNote(): boolean {
        return this.checkSecurity('BookingAddNote');
    }
    accessBookingRecalculate(): boolean {
        return this.checkSecurity('BookingRecalculate');
    }

    accessScheduleAdd(): boolean {
        return this.checkSecurity('ScheduleAdd');
    }
    accessScheduleUpdate(): boolean {
        return this.checkSecurity('ScheduleUpdate');
    }
    accessScheduleView(): boolean {
        return this.checkSecurity('ScheduleView');
    }
    accessSchedulesView(): boolean {
        return this.checkSecurity('SchedulesView');
    }
    accessBookingResendConfirmationEmail(): boolean {
        return this.checkSecurity('BookingResendConfirmationEmail');
    }

    checkSecurity(token: string): boolean {
        return true; // todo
        if (this.startStoreInfo === undefined ||
            this.startStoreInfo === null ||
            this.startStoreInfo.availableSecurityActions === undefined ||
            this.startStoreInfo.availableSecurityActions === null ||
            this.startStoreInfo.availableSecurityActions.length === 0 ) {
                return false;
            }

        const match = this.startStoreInfo.availableSecurityActions.find(
            item => item === token
        );

        if ( match !== undefined ) {
            return true;
        }
        return false;
    }
}
